module.exports = __webpack_public_path__ + "img/position-led.a3490871.png";